<template>
  <AppHeaderDropdown right caret>
    <template slot="header">
      <i style="color:white" class="fa fa-user"></i>
      <span style="color:white" v-if="authUser.nom">{{authUser.nom}}</span>
               
    </template>
    <template slot="dropdown">
     
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Deconnexion</b-dropdown-item>
      
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  computed:{
    ...mapGetters([
      'authUser'
    ])
  },
  methods:{
    ...mapActions([
      'logout'
    ])
  }
}
</script>
